var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.5312 7 13 7.46875 13 8C13 8.5625 12.5312 9 12 9C11.4375 9 11 8.5625 11 8C11 7.46875 11.4375 7 12 7ZM14.5 2C15.3125 2 16 2.6875 16 3.5V12C16 13.125 15.0938 14 14 14H3C1.3125 14 0 12.6875 0 11V3C0 1.34375 1.3125 0 3 0H12.5C13.3125 0 14 0.6875 14 1.5V2H14.5ZM15 12V3.5C15 3.25 14.75 3 14.5 3H3.5C3.21875 3 3 2.78125 3 2.5C3 2.25 3.21875 2 3.5 2H13V1.5C13 1.25 12.75 1 12.5 1H3C1.875 1 1 1.90625 1 3V11C1 12.125 1.875 13 3 13H14C14.5312 13 15 12.5625 15 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.28635cbe425c713e99a5066bcd7fa6d2.svg";
export { ForwardRef as ReactComponent };